// src/store/modules/orders/actions.js

import { get, post } from '@/services/api';
export default {
  async fetchOrders(context, { offset, count }) {
    console.log(`📦 Fetching orders | offset=${offset}, count=${count}`);
    try {
      const response = await get(
        `/order/get-order-list?offset=${offset}&count=${count}`
      );
      console.log('📦 Fetch Orders API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Orders API error:', error);
      throw error;
    }
  },

  async fetchOrdersByDate(_, payload) {
    console.log('📅 Fetching orders by date', payload);
    try {
      const response = await post('/order/fetch-order-list', {
        fromDate: payload.from,
        toDate: payload.to,
      });
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Orders by Date API error:', error);
      throw error;
    }
  },

  async moveOrderToPosition(_, payload) {
    console.log('🔄 Moving order to position:', payload);
    try {
      const response = await post('/order/move-order-to-position', {
        orderId: payload.order_id,
      });
      console.log('✅ Order moved successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ Error moving order:', error);
      throw error;
    }
  },
  async removeOrderFromPosition(_, payload) {
    console.log('🔄 Removing order from position:', payload);
    try {
      const response = await post('/order/remove-order-from-position', {
        optionPositionsId: payload.optionPositionsId,
      });
      console.log('✅ Order removed successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ Error moving order:', error);
      throw error;
    }
},
  async placeOrderList(_, payload) {
    try {
      console.log('📦 placeOrderList', payload.tradeOrderDetails);
      const resp = await post('/order/place-order-list', {
        tradePositionDataList: payload.tradeOrderDetails, // Corrected spelling here
      });
      return resp.data;
    } catch (err) {
      console.error('❌ placeOrderList error:', err);
      throw err;
    }
  }
};
